module.exports = __webpack_public_path__ + "static/presidents-of-war-bdc755cdaf9c0eab80a85f1d8d2897a5.jpg";